import { axiosRequest } from '@/util/axios-request';
var method = 'get';
var listUrl = '/web/operatelog/list';
export var listFn = function listFn(params) {
  return axiosRequest({
    url: listUrl,
    method: method,
    params: params
  });
};